export default __webpack_public_path__ + "img/f63cda540fde1be5220434afa644bbc6.svg";